<template>
  <div
    :class="{
      'chat-messages-list-item-user': to === 'Bot',
      'chat-messages-list-item-other': to === 'User',
      'chat-messages-list-item-system': to === 'System'
    }"
  >
    <div
      :class="{
        'chat-messages-list-item-user-message': to === 'Bot',
        'chat-messages-list-item-other-message': to === 'User',
        'chat-messages-list-item-system-message': to === 'System'
      }"
    >
      <div v-if="message.type.toLocaleLowerCase() === 'text'">
        <p v-html="formatChatMessage(message)"/>
      </div>
      <div
        v-else-if="message.type.toLocaleLowerCase() === 'image'"
        v-html="formatImageMessage(message)"
      />
      <div v-else-if="message.type.toLocaleLowerCase() === 'ptt'">
        <audio controls>
          <source :src="formatAudioMessage(message.fileBase)" type="audio/ogg">
        </audio>
      </div>
      <div v-else-if="message.type.toLocaleLowerCase() === 'list'">
        <strong><p>{{ message.title }}</p></strong>
        <div v-for="(section, index) in message.sections" :key="index">
          <ul>
            <li v-for="row in section.rows" :key="row.rowId">
              {{ row.title }}
            </li>
          </ul>
        </div>
      </div>
      <div v-else-if="message.type.toLocaleLowerCase() === 'document'">
        <div
          class="chat-message-document"
          @click="handleDownloadFile(message)"
        >
          <span
            class="chat-message-document-icon"
          >
            <i class="fas fa-download"/>
          </span>
          <div class="chat-message-document-file">
            <span class="chat-message-document-file-name">Arquivo</span>
            <span class="chat-message-document-file-format">.{{ message.mimeType.split('/')[1] }}</span>
          </div>
        </div>
      </div>

      <div
        :class="{
          'chat-messages-list-item-user-message-notifications': to === 'Bot',
          'chat-messages-list-item-other-message-notifications': to === 'User',
          'chat-messages-list-item-system-message-notifications': to === 'System'
        }"
      >
      <div v-if="message.type.toLocaleLowerCase() === 'transferir'">
        <div class="chat-messages-actions"><p>Essa conversa foi transferida para {{message.text}} <i v-if="description !== null" class="fa fa-info-circle" :title="description"></i></p></div>
      </div>
      <div v-else-if="message.type.toLocaleLowerCase() === 'assumir'">
        <div class="chat-messages-actions"><p>Essa conversa foi assumida por {{message.text}} <i v-if="description !== null" class="fa fa-info-circle" :title="description"></i></p></div>
      </div>
        <div class="message-status">
          {{ moment(date).format('HH:mm') }}
          <span class="ml-1">
            <i v-if="sent" class="fas fa-check"/>
            <i v-else class="fas fa-clock"/>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatMessage',
  props: {
    to: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    message: {
      type: Object,
      required: false
    },
    date: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    sent: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    formatChatMessage (message) {
      if (!message.text) {
        return ''
      }
      return (message.text).replaceAll('\n', '<br>').replaceAll(/\*\*(.*?)\*\*/g, '<b>$1</b>')
    },
    formatChatTransfer (message) {
      return ('TRANSFERIDO').replaceAll('\n', '<br>').replaceAll(/\*\*(.*?)\*\*/g, '<b>$1</b>')
    },
    formatImageMessage (message) {
      const {fileBase} = message
      return `<img class="chat-message-image" src="data:image/jpeg;base64,${fileBase}" />`
    },
    formatAudioMessage (base64) {
      return `data:audio/ogg;base64,${base64}`
    },
    handleDownloadFile (message) {
      const { fileBase, mimeType } = message
      const blob = this.base64ToBlob(fileBase, mimeType)
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `file.${mimeType.split('/')[1]}`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    base64ToBlob (message) {
      const { fileBase, mimeType } = message
      const byteString = window.atob(fileBase)
      const arrayBuffer = new ArrayBuffer(byteString.length)
      const int8Array = new Uint8Array(arrayBuffer)

      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i)
      }

      const blob = new Blob([int8Array], { type: mimeType })
      return blob
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/historico_atendimento/components/chat/ChatMessage.vue